import { Controller } from "stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static targets = ["container", "backdrop", "panel"];

  static values = { shouldOpen: Boolean };

  connect() {
    document.addEventListener("turbo:submit-end", async (event) => {
      if (event.detail.success) {
        await this.close();
      }
    });

    // Auto-open if shouldOpen is true - but without animation on initial load
    if (this.shouldOpenValue) {
      this.openWithoutAnimation();
    }
  }

  open() {
    this.containerTarget.classList.remove("hidden");
    enter(this.backdropTarget);
    enter(this.panelTarget);
  }

  openWithoutAnimation() {
    // Open immediately without transitions for page load
    this.containerTarget.classList.remove("hidden");
    this.backdropTarget.classList.remove("opacity-0");
    this.panelTarget.classList.remove("translate-x-full");
  }

  async close() {
    return Promise.all([
      leave(this.backdropTarget),
      leave(this.panelTarget),
    ]).then(() => {
      this.containerTarget.classList.add("hidden");
    });
  }
}
